<template>
  <v-btn-toggle
    v-if="chipList && chipList.length"
    v-model="model"
    class="asc-zoom-chips"
    mandatory
    @change="chipSelected"
  >
    <asc-zoom-chip
      v-for="(chip, i) in chipList"
      :key="i"
      :value="chip.value"
      :text="chip.text"
      :is-active="i === model"
    />
  </v-btn-toggle>
</template>

<script>
import AscZoomChip from '@/components/atoms/AscZoomChip'

export default {
  name: 'AscZoomChips',

  components: {
    AscZoomChip,
  },

  props: {
    activeChip: {
      type: Number,
      default: 5,
    },
    chipList: {
      type: Array,
      default: () => [],
    },
    onSelectChip: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      viewModel: this.activeChip,
    }
  },

  computed: {
    model: {
      get() {
        return this.viewModel
      },
      set(newVal) {
        this.viewModel = newVal
      },
    },
  },

  methods: {
    chipSelected(whichIndex) {
      // grab the value of the chip object based on the
      // selected index
      this.onSelectChip(this.chipList[whichIndex].value)
    },
  },
}
</script>

<style lang="scss">
.asc-zoom-chips {
  box-shadow: none;

  .v-btn {
    opacity: 1;
  }

  .asc-zoom-chip {
    margin: 0 2px;
  }

  .v-btn--active::before {
    background-color: initial;
  }
}
</style>
